import { render } from "./IntegrationSettings.vue?vue&type=template&id=5abc1a8f"
import script from "./IntegrationSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__